import React from "react";
import i18n from "i18n";
import BootstrapModalForm from "components/bootstrap/BootstrapModalForm";
import Input from "components/bootstrap/Input";
class QueryTitleEditModal extends React.Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line react/no-unused-class-component-methods
    this.open = (activeQueryTitle) => {
      this.setState({
        titleDraft: activeQueryTitle,
        showModal: true
      });
    };
    this.close = () => {
      this.setState({ showModal: false });
    };
    this._onDraftSave = () => {
      const { titleDraft } = this.state;
      const { onTitleChange } = this.props;
      onTitleChange(titleDraft);
      this.close();
    };
    this._onDraftChange = (evt) => {
      this.setState({ titleDraft: evt.target.value });
    };
    this.state = {
      showModal: false,
      titleDraft: ""
    };
  }
  render() {
    const { titleDraft, showModal } = this.state;
    return /* @__PURE__ */ React.createElement(
      BootstrapModalForm,
      {
        show: showModal,
        title: i18n.t("query_title.edit_modal_title", { ns: "search" }),
        onSubmitForm: this._onDraftSave,
        onCancel: this.close,
        submitButtonText: i18n.t("query_title.update_title", { ns: "search" }),
        bsSize: "large"
      },
      /* @__PURE__ */ React.createElement(
        Input,
        {
          autoFocus: true,
          help: i18n.t("query_title.title_help", { ns: "search" }),
          id: "title",
          label: i18n.t("query_title.title", { ns: "search" }),
          name: "title",
          onChange: this._onDraftChange,
          maxLength: 40,
          required: true,
          type: "text",
          value: titleDraft
        }
      )
    );
  }
}
export default QueryTitleEditModal;
